module.exports = __webpack_public_path__ + "static/contact_mobile-516e5e472988f30c68b69796cd20bef1.jpg";